import { ACCOUNT_LOCKED, DEVICE_LOCKED } from '../constants/initiator-flow-enums';
import getHeaderValue from './get-header-value';

const isAccountDeviceLocked = response => {
  const { error, errorCode, headers, httpStatus } = response;
  const lookupStatus = response?.data?.lookupStatus ?? null;
  let xAppEventCode = null;
  if (headers) {
    xAppEventCode = getHeaderValue(headers, 'x-app-event-code');
  }
  const isDeviceLock =
    (httpStatus === 400 && errorCode === 'invalid_grant_devicelockout') ||
    (httpStatus === 423 && (errorCode === 'VMG-00230' || errorCode === 1087)) ||
    xAppEventCode === 'VMG-00230';
  const isAccountLock =
    // VCO-14530: /token call failure in ACCOUNT_LOCKED scenario uses response.error
    (httpStatus === 400 &&
      (errorCode === 'invalid_grant_loginlockout' || error === 'invalid_grant_loginlockout')) ||
    (httpStatus === 423 || errorCode === 'VMG-002') ||
    lookupStatus === 'USERNOTALLOWED' ||
    xAppEventCode === 'VMG-00240';

  // Removing the default 403 lock error.
  // Assumption -  BE team delviered F8575 and as part of this feature
  // standardized all account/device lock errors to 423
  // httpStatus === 403;
  /** Please don't change the order - This will define the valid lock out error flow **/
  if (isDeviceLock) {
    return DEVICE_LOCKED;
  } else if (isAccountLock) {
    return ACCOUNT_LOCKED;
  }
  return null;
};

export default isAccountDeviceLocked;
